import { OncomingEventList } from "../OncomingEventList";
import { EventList } from "../EventList";
import { CategoryPicker } from "../CategoryPicker";
import { EventDialog } from "../EventDialog";

export function DatesRoot() {

	return (
		<>
			<div class="grid grid-rows-[max-content_72px_1fr] lg:grid-cols-12 lg:gap-x-12 lg:grid-rows-1">
				<CategoryPicker class="row-start-2 mb-12 lg:col-start-5 lg:col-end-13 lg:row-start-1" />
				<OncomingEventList class="row-start-1 mb-8 lg:mb-0 lg:col-start-1 lg:col-end-5 lg:row-start-2" />
				<EventList class="grid row-start-3 gap-y-6 lg:col-start-5 lg:col-end-13 lg:row-start-2" />
			</div>
			<EventDialog />
		</>
	);
}